import { removeElement, setElement } from "@services/storage/elements";
import {
  removeGroupFilenames,
  setGroupFilenames,
} from "@services/storage/filenames";
import { $$ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";
import type { StoredElement, FilePathTuple } from "@app-types/index";

/**
 * Handle clear selection button click
 * Removes group from both elements and filenames localStorage
 */
function handleClearSelection(event: MouseEvent): void {
  const button = event.currentTarget as HTMLButtonElement;
  const groupId = button.dataset.clearSelection;
  const category = button.dataset.category;

  if (!groupId || !category) return;

  removeElement(groupId);
  removeGroupFilenames(groupId);

  // Redirect to category page
  window.location.href = `/${category}`;
}

/**
 * Handle set transparent button click
 * Sets element as transparent with zeroed properties
 */
function handleSetTransparent(event: MouseEvent): void {
  const button = event.currentTarget as HTMLButtonElement;
  const groupId = button.dataset.setTransparent;
  const category = button.dataset.category;
  const groupName = button.dataset.groupName;

  if (!groupId || !category || !groupName) return;

  // Save transparent element data
  const elementData: StoredElement = {
    element_id: "transparent",
    is_hd: "0",
    is_animated: "0",
    frames: "0",
    group_name: groupName,
    category: category,
  };
  setElement(groupId, elementData);

  // Save transparent/silent file paths based on category
  const filePaths: FilePathTuple[] =
    category === "sounds"
      ? [["silent.wav", `${groupName}.wav`]]
      : [
          ["transparent.png", `${groupName}.png`],
          ["transparent.png", `${groupName}@2x.png`],
        ];
  setGroupFilenames(groupId, filePaths);

  // Redirect to category page
  window.location.href = `/${category}`;
}

/**
 * Initialize group options functionality
 * Attaches click handlers to option buttons
 */
export function initGroupOptions(): void {
  const clearButtons = $$(DATA_ATTR.CLEAR_SELECTION);
  clearButtons.forEach((button) => {
    button.addEventListener("click", handleClearSelection as EventListener);
  });

  const transparentButtons = $$(DATA_ATTR.SET_TRANSPARENT);
  transparentButtons.forEach((button) => {
    button.addEventListener("click", handleSetTransparent as EventListener);
  });
}
